"use client";

import {
  defineIcons,
  ExtraIcons,
  ExtraIconsProvider,
} from "@gnist/design-system";
import {
  FilterIcon,
  Calendar,
  Speed,
  GasStation,
  Gearshift,
  ImageIcon,
} from "../components/icons";
import React from "react";

// NB! When adding new svg's, make sure to remove height and width properties in svg-code to allow proper size to be set.
const appIcons = defineIcons({
  filter_icon: {
    filled: FilterIcon,
    options: { fit: "width", scale: 1 },
  },
  new_calendar: {
    filled: Calendar,
    options: { fit: "width", scale: 1 },
  },
  speed: {
    filled: Speed,
    options: { fit: "width", scale: 1 },
  },
  new_gas_station: {
    filled: GasStation,
    options: { fit: "width", scale: 1 },
  },
  gearshift: {
    filled: Gearshift,
    options: { fit: "width", scale: 1 },
  },
  image_icon: {
    filled: ImageIcon,
    options: { fit: "height", scale: 1.1 },
  },
});
type AppIcons = typeof appIcons;

declare module "@gnist/design-system" {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface ExtraIcons extends AppIcons {}
}

export const ExtraIconsRegistry = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <ExtraIconsProvider icons={appIcons as ExtraIcons}>
      {children}
    </ExtraIconsProvider>
  );
};
